import http from "infra/http";
import { useMutation } from "react-query";
import { NotificacaoConfiguracaoForm } from "../typings";

function useSaveNotificacaoCobranca() {
  return useMutation(
    [`/v1/notificacao-cobranca`],
    async (form: NotificacaoConfiguracaoForm) => {
      const { data } = await http.post(`/v1/notificacao-cobranca`, {
        ...form,
      });
      return data;
    }
  );
}

export default useSaveNotificacaoCobranca;
